export const isoDateToUPCCovertor = (
  isoDateString: string,
  timeZone: string
) => {
  // Parse the ISO date string
  const date = new Date(isoDateString);

  const options: any = timeZone
    ? {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone,
      }
    : {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      };

  // Format the date with locale options
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);

  // Remove the "at" and the time zone abbreviation if present
  const cleanDate = formattedDate.replace(/,? at /, " ");

  return cleanDate;
};
